WiseMetering.Collection.ZoneReportTypes = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.ZoneReportType,
    url: '/report_types/zone_report_types',

    filterTypes: function(siteId) {
        const siteHasReports = WiseMetering.reports.where({ type: 'SiteInvoiceReport', site_id: siteId }),
            hasAccess = this.isException(siteId) ? false : siteHasReports.length > 0,
            types = hasAccess ? this : this.standardGlobalReportSuite();

        types.each(report => {
            let active = true;
            if (['SiteDetailedReport', 'SiteFolderReport', 'SiteMeteringSchemaReport', 'SiteSchemaReport'].includes(report.get('type'))) {
                active = WiseMetering.Permissions.hasPlanPermissions('standardReports');
            }
            report.set({ active });
        });
        return types.grouped();
    },

    grouped: function() {
        return _.groupBy(this.toJSON(), function(model) {
            return model.category;
        });
    },

    //to be deleted once all clients stop using invoice reporting
    isException: function(siteId) {
        const
            isIosa = ['iosa'].includes(WiseMetering.currentOrganization.get('subdomain')),
            isRamazzotti = siteId === 'a6b00283-1412-4c50-8261-e78f30f69874';

        return isIosa || isRamazzotti;
    },

    standardGlobalReportSuite: function() {
        let reports = this.filter((report) => report.get('type') !== 'SiteInvoiceReport');
        return new WiseMetering.Collection.ZoneReportTypes(reports);
    }
});
